import React from 'react';
import './Footer.css';
import { IoLogoLinkedin } from 'react-icons/io';
import { HiOutlineMail } from 'react-icons/hi';
import { NavLink } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <h3 className="footer-title">1WAYDOOR</h3>
            <p className="footer-desc">
              Your trusted partner in software services and consulting.
              We help businesses thrive in the digital landscape.
            </p>
            <div className="footer-social">
              <a href="mailto:support@1waydoor.com" aria-label="Email us" className="footer-social-link">
                <HiOutlineMail />
              </a>
              <a href="https://www.linkedin.com/company/1waydoor" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="footer-social-link">
                <IoLogoLinkedin />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-links-group">
              <h4>Company</h4>
              <ul>
                <li><NavLink to="/about">About</NavLink></li>
                <li><NavLink to="/service">Services</NavLink></li>
                <li><NavLink to="/client">Clients</NavLink></li>
                <li><NavLink to="/contact">Contact</NavLink></li>
              </ul>
            </div>
            <div className="footer-links-group">
              <h4>Legal</h4>
              <ul>
                <li><NavLink to="/privacy">Privacy Policy</NavLink></li>
                <li><NavLink to="/terms">Terms of Service</NavLink></li>
              </ul>
            </div>
            <div className="footer-links-group">
              <h4>Contact</h4>
              <ul>
                <li><a href="mailto:support@1waydoor.com">support@1waydoor.com</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} 1WayDoor LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
